export type FairIconSvgMode = 'monochrome' | 'brand'

export function prepareIconSvg(svg: string, mode: FairIconSvgMode): string {
  if (mode === 'brand') {
    return svg
      .replace(/fill="var\(--fill-\d+,\s*([^"]+)\)"/g, 'fill="$1"')
      .replace(/stroke="var\(--stroke-\d+,\s*([^"]+)\)"/g, 'stroke="$1"')
      .trim()
  }

  return svg
    .replace(/preserveAspectRatio="none"/g, 'preserveAspectRatio="xMidYMid meet"')
    .replace(/\swidth="100%"/g, '')
    .replace(/\sheight="100%"/g, '')
    .replace(/\soverflow="visible"/g, '')
    .replace(/\sstyle="display:\s*block;"/g, '')
    .replace(/fill="var\(--fill-\d+,\s*[^"]*\)"/g, 'fill="currentColor"')
    .replace(/stroke="var\(--stroke-\d+,\s*[^"]*\)"/g, 'stroke="currentColor"')
    .replace(/fill="white"/g, 'fill="currentColor"')
    .replace(/stroke="white"/g, 'stroke="currentColor"')
    .trim()
}
